import { Flagent_cfg } from '../models/datapoint/flagent_cfg';

export class Flagent_cfgsUtil {
    private static instance: Flagent_cfgsUtil;

    static getInstance() {
        if (!Flagent_cfgsUtil.instance) {
            Flagent_cfgsUtil.instance = new Flagent_cfgsUtil();
        }

        return Flagent_cfgsUtil.instance;
    }

    /**
    * Flagent_cfgsUtil is a singleton class, so use Flagent_cfgsUtil.getInstance() method instead of creating new Flagent_cfgsUtil().
    */
    private constructor() {

    }

    copy(flagent_cfgs: Array<Flagent_cfg>): Array<Flagent_cfg> {
        let flagent_cfgsTmp: Array<Flagent_cfg> = new Array<Flagent_cfg>();

        for (let i: number = 0; i < flagent_cfgs.length; i++) {
            flagent_cfgsTmp.push(Flagent_cfg.parse(flagent_cfgs[i]));
        }

        return flagent_cfgsTmp;
    }

    copyFrom(flagent_cfgs: Array<Flagent_cfg>, flagent_cfgsTmp: Array<Flagent_cfg>): void {
        let flagent_cfgsMap: Map<number, Flagent_cfg> = new Map();

        for (let i: number = 0; i < flagent_cfgs.length; i++) {
            let flagent_cfg: Flagent_cfg = flagent_cfgs[i] as Flagent_cfg;
            flagent_cfgsMap.set(flagent_cfg.fla_Cfg_Id, flagent_cfg);
        }
        flagent_cfgs.splice(0, flagent_cfgs.length);

        for (let i: number = 0; i < flagent_cfgsTmp.length; i++) {
            let flagent_cfgTmp: Flagent_cfg = flagent_cfgsTmp[i] as Flagent_cfg;

            let flagent_cfg: Flagent_cfg = flagent_cfgsMap.get(flagent_cfgTmp.fla_Cfg_Id);
            if (flagent_cfg) {
                flagent_cfg.copyFrom(flagent_cfgTmp);
            } else {
                flagent_cfg = Flagent_cfg.parse(flagent_cfgTmp);
            }

            flagent_cfgs.push(flagent_cfg);
        }
    }

    compare(flagent_cfgs: Array<Flagent_cfg>, flagent_cfgsTmp: Array<Flagent_cfg>): string {
        let flagent_cfgsLength = flagent_cfgs.length;
        let flagent_cfgsTmpLength = flagent_cfgsTmp.length;

        if (flagent_cfgsLength != flagent_cfgsTmpLength) {
            return 'Flagent_cfg length is different.';
        }

        for (let i: number = 0; i < flagent_cfgsLength; i++) {
            let flagent_cfg: Flagent_cfg = flagent_cfgs[i] as Flagent_cfg;
            let flagent_cfgTmp: Flagent_cfg = flagent_cfgsTmp[i];

            if (flagent_cfg.compare(flagent_cfgTmp) != '') {
                return 'flagent_cfgs [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(flagent_cfgs: Array<Flagent_cfg>): string {
        let str: string = '';

        for (let i: number = 0; i < flagent_cfgs.length; i++) {
            str += flagent_cfgs[i].toString();
        }

        return str;
    }
}